// HubSpot gets its allowlist from server-owned site settings, never from a URL parameter.
let confirmedOrigin = "";

function allowedOrigins(): string[] {
    const options = (window as any).ZIDXOptions || {};
    if (options.hubspotEmbed) return options.allowedParentOrigins || [];
    const origins = [options.proxyDomain, options.siteDomain];
    // Existing Wix and WordPress embeds may use a different published origin.
    if (document.referrer) {
        try { origins.push(new URL(document.referrer).origin); } catch {}
    }
    return origins.filter((value): value is string => typeof value === "string" && !!value);
}

export function acceptParentMessage(event: MessageEvent): boolean {
    if (event.source !== window.parent || !allowedOrigins().includes(event.origin)) return false;
    confirmedOrigin = event.origin;
    return true;
}

export function postToParent(message: unknown): void {
    if (window.parent === window) return;
    if (!confirmedOrigin && document.referrer) {
        try {
            const origin = new URL(document.referrer).origin;
            if (allowedOrigins().includes(origin)) confirmedOrigin = origin;
        } catch {}
    }
    if (confirmedOrigin) window.parent.postMessage(message, confirmedOrigin);
}
